import React from 'react'
import { Box, BoxProps } from 'rebass/styled-components'

export const LoadingImage = ({ children, sx, ...props }: BoxProps): JSX.Element => (
  <Box
    data-name="LoadingImage"
    sx={{ backgroundColor: 'grey100', borderRadius: '3px', maxWidth: '100%', ...sx }}
    {...props}
  >
    {children}
  </Box>
)
